import common_es from './common.json';

export default {
  common: common_es,
};
